import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Typography } from '@material-ui/core';

export default function SkeletonLoad() {
  return (
    <div style={{display:'flex'}}>
      <div style={{background:'white',padding:'15px',paddingTop:'0px',borderRadius:'15px',width:'35vh'}}><Skeleton variant="rect" style={{borderRadius:'15px'}} animation='wave'  height={200} /></div>
      <div>
      <Typography style={{background:'white',width:'200px',margin:'5px',borderRadius:'2px'}}  variant='body1'><Skeleton variant="text" animation='wave'  /></Typography>
      <Typography style={{background:'white',width:'200px',margin:'5px',borderRadius:'2px'}}  variant='body1'><Skeleton variant="text" animation='wave'  /></Typography>
      <Typography style={{background:'white',width:'200px',margin:'5px',borderRadius:'2px'}}  variant='body1'><Skeleton variant="text" animation='wave' /></Typography>
      </div>
    </div>
  );
}